import React, { Component } from "reactn";
import { $ } from "js/vendor";
import { UIController } from "../dialogs/UIController";
import { WhiteIconButton } from "js/react/components/UiComponents";
import { Icon } from "@material-ui/core";
import { Key } from "js/core/utilities/keys";
import { ds } from "js/core/models/dataService";
import PresentationEditorController, { PanelType } from "../PresentationEditor/PresentationEditorController";

export class HelpButton extends Component {
    componentDidMount() {
        // Global shortcuts
        $(window).on("keydown.help", event => {
            //Protect against input fields so that we don't accidentally trigger these key events.
            if (event.target.tagName === "INPUT") {
                return;
            }
            event.stopPropagation();
            switch (event.which) {
                // Open the help menu on Cmd/Ctrl + ?
                case Key.FORWARD_SLASH:
                    if (event.metaKey || event.ctrlKey) {
                        PresentationEditorController.togglePanel(PanelType.SHORTCUTS);
                        event.preventDefault();
                        return;
                    }
                    break;
            }
        });
    }

    componentWillUnmount() {
        // Stop listening for shortcuts
        $(window).off("keydown.help");
    }

    handleShowHelpPanel = event => {
        ds.selection.element = null;
        UIController.showHelpPanel(this.props.source, event.shiftKey);
    }

    render() {
        return (
            <WhiteIconButton className="help-button" onClick={this.handleShowHelpPanel}>
                <Icon>help</Icon>
            </WhiteIconButton>
        );
    }
}
